import { render, staticRenderFns } from "./Caret.vue?vue&type=template&id=1643a68a&scoped=true&"
import script from "./Caret.vue?vue&type=script&lang=js&"
export * from "./Caret.vue?vue&type=script&lang=js&"
import style0 from "./Caret.vue?vue&type=style&index=0&id=1643a68a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643a68a",
  null
  
)

export default component.exports